import { affiliateDiscountCodeActions } from '../constants/index'

export const setAffiliateDiscountCodes = (code) => {
  return {
    type: affiliateDiscountCodeActions.SET_AFFILIATE_DISCOUNT_CODES,
    payload: code
  }
}
